import { Box, Stack, Typography, CircularProgress } from "@mui/material";
import React, { useEffect, useState, useCallback, useRef  } from "react";
import "../cssfiles/homepage.css";
import Logo_Company from "../images/PlantLogo.png";
import IncArrow from "../images/IncArrow.svg";
import IconEnergy from "../images/IconEnergy.svg";
import IconEmission from "../images/IconEmission.svg";
import DecArrow from "../images/DecArrow.svg";
import RupeesIcon from "../images/RupeesIcon.svg";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import ExpandIcon from "../images/ExpandIcon.svg";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import {
  updateoverviewbarstate,
  updateselectedprojectname,
} from "../store/mainpage_data";
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
/*import Settings from '../images/Settings.svg';
import Report from '../images/Report.svg';*/
import Divider from "@mui/material/Divider";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { setPage } from "../store/pageselect_data";
import LK_home from "../images/LK_Home.png";
import LK_settings from "../images/LK_Settings.png";
import {  updateliveoverviewdata} from "../store/mainpage_data";
//import { ReactComponent as LK_Settings } from '../images/LK_Settings.svg'
//import { ReactComponent as LK_Home } from '../images/LK_Home.svg'
import { Menu, MenuItem } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import userEvent from "@testing-library/user-event";
import plantlogo2 from "../images/PlantLogo_2.png";
import plantlogo3 from "../images/PlantLogo_3.png";
import dominoslogo from "../images/Dominos.png";
import dunkinlogo from "../images/Dunkin.png";
import popeyeslogo from "../images/Popeyes.png";
import hongslogo from "../images/hongskitchen.png";
import BlurCircularIcon from '@mui/icons-material/BlurCircular';
import ProtectedComponent from "./ConfigPages/UserAccessManangement/ProtectedComponent.jsx";
import LK_Home from "../images/LK_Home.js";
import LK_Settings from "../images/LK_Settings.js";
import LK_Useradministration from "../images/LK_Usermanagement.js";
import LK_Reports from "../images/LK_Reports.js";
import LK_Alarm from "../images/LK_Alarm.js";
import LK_Audit from "../images/LK_Audit.js";
import LK_Ticket from "../images/LK_Ticket.js";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import {
  updatetreepathselected,
  updatetreeintialpath,
} from "../store/mainpage_data";
import { updateoverviewbarCollection, updateoverviewbarConfigCollection} from "../store/cofig_data";
import {
  getOverviewbarData,
  getOverviewbarParameterData,
  changeselectedproject,
  getOverviewConfig,
  livedata as fetchlivedata,
} from "../Restclient/datacollection.js";
import CustomTooltip from "../pages/CommonComponents/CustomTooltip.js";
export default function Overviewbar() {
  const dispatch = useDispatch();
  const selectedPage = useSelector(
    (state) => state.pageselectdata.selectedPage
  );
  const themechange = useSelector((state) => state.themedata.theme);
  const { PermissionsArray: usrPrmns } = useSelector(
    (state) => state.logindata.userdetails
  );
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const projectdetails = useSelector((state) => state.logindata.projectdata);
  const organizationdetails = useSelector(
    (state) => state.logindata.organisationdata
  );
  const livealarmarray = useSelector((state) => state.alarmdata.livealarmarray);
  const projectname = useSelector(
    (state) => state.mainpagedata.selectedprojectname
  );
  const selectedprojectname = useSelector(
      (state) => state.mainpagedata.selectedprojectname
    );

  const { PermissionsArray: userPermissions } = useSelector(
    (state) => state.logindata.userdetails
  );
  const [isExpanded, setIsExpanded] = useState(true);
  const [index, setindex] = useState(1);
  const [anchorE1, setAnchorE1] = useState(null);
  const [clientdatajson, setClientdatajson] = useState({
    client: "",
    project: "",
    place: "",
  });
  const [logobase64, setLogobase64] = useState();
  const [showsuper, setShowsuper] = useState(false);
  const [overviewbarData, setoverviewbarData] = useState([
    [0, 0, 0],
    [0, 0, 0],
  ]);
  const livedata = useSelector((state) => state.mainpagedata.livedata);
  const liveoverviewdata = useSelector((state) => state.mainpagedata.liveoverviewdata);
  const overviewbarCollection = useSelector((state) => state.configdata?.overviewbarCollection) || [];
  
  const overviewbarIntervalRef = useRef(null);
  const [criticalExpandParameters, setCriticalExpandParameters] = useState([]);
  const [noncriticalExpandParameters, setNoncriticalExpandParameters] = useState([]);
  const [criticalCollapseParameters, setCriticalCollapseParameters] = useState([]);
  const [noncriticalCollapseParameters, setNonCriticalCollapseParameters] = useState([]);
  const tagdetailsobject = useSelector((state) => state.mainpagedata.tagdetailsobject);
  const dateselected = useSelector((state) => state.mainpagedata.selecteddate);
  const selecteddates_dashboard = useSelector((state) => state.mainpagedata.selecteddates_dashboard);
  const [count_of_alarms_events, setCountOfAlarmsEvents] = useState(0);
  const devicedetailsobject  = useSelector((state) => state.mainpagedata.devicedetailsobject )
  // Add refs for preventing duplicate calls
  const isProcessingRef = useRef(false);
  const abortControllerRef = useRef(null);
  const lastCallParamsRef = useRef(null);
  // Loading state for showing CircularProgress initially
  const [isInitialLoading, setIsInitialLoading] = useState(true);
  
  // Timeout to transition from loading to showing actual values
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsInitialLoading(false);
    }, 3000); // Show loading for 3 seconds
    
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    //setInterval(() => {
    // console.log("alarm set interval")
    //    getalarmeventsrecords(alarmeventsrecordscallback);
    //}, 10);
    if(Array.isArray(livealarmarray)) {
      if(livealarmarray.length >= 0){
          setCountOfAlarmsEvents(livealarmarray.length);
      }else{
        setCountOfAlarmsEvents(0);
      }
        
    }
  }, [livealarmarray,selectedprojectname]);

  useEffect(() => {
      const liveParamNames = overviewbarCollection
        .filter((p) => p.RepresentType === 'LIVE')
        .map((p) => p.ParameterName)
        .filter(Boolean);
      if (!liveParamNames.length) return;
      const payload = { tagids: [], overviewbarparameters: liveParamNames };
      const overviewCallback = (res) => {
        try {
          dispatch(updateliveoverviewdata(res.data.overviewParameterDataMap || {}));
        } catch (_) {}
      };
      fetchlivedata(payload, overviewCallback);
      overviewbarIntervalRef.current = setInterval(() => fetchlivedata(payload, overviewCallback), 60000);
      return () => {
        clearInterval(overviewbarIntervalRef.current);
        overviewbarIntervalRef.current = null;
      };
    }, [overviewbarCollection]);
    
  function notificationsLabel(count) {
    /*if (count === 0) {
        return 'no notifications';
    }
    if (count > 99) {
        return 'more than 99 notifications';
    } */
    // console.log("count obtd*****)))))))))//////////////////",count)
    return `${count} notifications`;
  }
  const createdata = (client, project, place) => {
    return { client, project, place };
  };

  const clients = [
    //createdata('ACE Company Ltd', 'ACE HQ', 'Mumbai, India'),
    //createdata('ACE Company Ltd', 'ACE Baroda', 'Baroda, India'),
    //createdata('ACE Company Ltd', 'ACE Delhi', 'Delhi, India')
  ];

  /*const clients_kolkata = [
        createdata('XYZ Company Ltd', 'XYZ Kolkata', 'Kolkata, India'),
    ]

    const clients_JBF = [
        createdata('Jubilant FoodWorks Ltd', 'Jubilant HQ', 'Noida, India'),
        createdata('DOMINOS', 'DOMINOS-Jubilant Foodworks', 'Ghaziabad, India'),
        createdata('DUNKIN', 'DUNKIN-Jubilant Foodworks', 'Noida, India'),
        createdata('POPEYES', 'POPEYES-Jubilant Foodworks', 'Bengaluru, India'),
        createdata("HONG'S Kitchen", "HONG'S Kitchen-Jubilant", 'Noida, India'),
    ]*/

  const [projectlist, setProjectlist] = useState(clients);

  
  const handlePageChange = (page) => {
    //console.log("page ", page)
    dispatch(setPage(page));
  };

  const handleExpandClick = () => {
    dispatch(updateoverviewbarstate(!isExpanded));
    setIsExpanded(!isExpanded);
  };
  const dataSeries = [
    "7000.00",
    "6000.00",
    "2250.00",
    "475.00",
    "0.00",
    "25.00",
    "250.00",
    "0.18",
    "3125.00",
  ];
  const dataSeries_baroda = [
    "7000.00",
    "6000.00",
    "2250.00",
    "475.00",
    "0.00",
    "25.00",
    "250.00",
    "0.18",
    "3125.00",
  ];
  const dataSeries_delhi = [
    "5600.00",
    "4800.00",
    "1860.00",
    "352.00",
    "0.00",
    "48.00",
    "140.00",
    "0.11",
    "1750.00",
  ];
  const dataSeries_Hq = [
    "12600.00",
    "10800.00",
    "4110.00",
    "827.00",
    "0.00",
    "73.00",
    "390.00",
    "0.29",
    "4875.00",
  ];
  const dataSeries_kolkata = [
    "10000.00",
    "8400.00",
    "827.00",
    "640.00",
    "0.00",
    "60.00",
    "400.00",
    "0.3",
    "5000.00",
  ];

  const [data, setdata] = useState(dataSeries);
  const handleClose = () => {
    setAnchorE1(null);
  };
  const handleClick = (event) => {
    //console.log("click on dropdown")
    setAnchorE1(event.currentTarget);
  };

  const handletablerowclick = (row, index) => {
    setClientdatajson(row);
    dispatch(updateselectedprojectname(row.projectid));
    changeselectedproject(index);
  };

  useEffect(() => {
    try {
      // Only proceed if we have valid data
      if (projectname && Array.isArray(projectlist) && projectlist.length > 0) {
        // Find the project in projectlist that matches the selectedprojectname
        const matchingProject = projectlist.find(
          (project) => project && project.projectid === projectname
        );

        if (matchingProject) {
          console.log(
            "Updating client data from Redux:",
            matchingProject,
            projectlist,
            projectname
          );
          // Update the local state to reflect the selected project
          setClientdatajson(matchingProject);
        }
      }
    } catch (error) {
      console.error("Error in projectname effect:", error);
    }

    if(projectname != '' && projectname!= undefined && projectname!=null){
      console.log("before calling projectid",projectname)
      makeOverviewConfigCall(getOverviewConfigcallback);
    }
  }, [projectname, projectlist]);

  const prefixMultipliers = {
      '': 1,
      'm': 0.001,
      'c': 0.01,
      'd': 0.1,
      'da': 10,
      'h': 100,
      'k': 1000,
      'M': 1000000,
      'G': 1000000000
    };

    const prefixMultipliersParamUnit = {
      'Unit': 1,
      'Milli': 1000,
      'Centi': 100,
      'Deci': 10,
      'Deca': 0.1,
      'Hecto': 0.01,
      'Kilo': 0.001,
      'Mega': 0.000001,
      'Giga': 0.000000001,
      'Tera': 0.000000000001
    };

    function parseUnit(unit) {
      // Match prefix (optional) + base unit (e.g., kWh, MW, mVA, Wh, W, VA, etc.)
      const match = unit.match(/^(da|[mcdhkMG]?)([A-Za-z]+)$/);
      if (!match) return { prefix: '', base: unit, multiplier: 1 };
      const [, prefix, base] = match;
      return {
        prefix,
        base,
        multiplier: prefixMultipliers[prefix] || 1,
      };
    }

     useEffect(() => {
      return () => {
        // Cleanup on unmount
        if (abortControllerRef.current) {
          abortControllerRef.current.abort();
        }
        isProcessingRef.current = false;
      };
    }, []);

    // Modified API call with duplicate prevention
    const makeOverviewConfigCall = (getOverviewConfigcallback) => {
      // Prevent duplicate calls
      if (isProcessingRef.current) {
        console.log("API call already in progress, skipping");
        return;
      }
      
      // Cancel previous request if still pending
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      
      // Create new abort controller
      abortControllerRef.current = new AbortController();
      isProcessingRef.current = true;
      
      getOverviewConfig(getOverviewConfigcallback);
    };

  const getOverviewConfigcallback = (res) => {
        console.log("getOverviewConfigcallback res---", res);
        // Reset processing flag
        isProcessingRef.current = false;

        // Add null/undefined check first
        if (!res || (res && res.status !== 200)) {
          console.error("Response is undefined or null");
          dispatch(updateoverviewbarCollection([]));
          dispatch(updateoverviewbarConfigCollection([]));
          return;
        }

        // Add check for res.data existence
        if (!res.data) {
          console.error("Response data is undefined");
          //return;
        }

        console.log("isProcessingRef-isProcessingRef",isProcessingRef)
        if(res.data && res.data.success && res.data.success == true){

          console.log("getOverviewConfigcallback res.data.data---", res.data);
          let configdata = res.data.data;
          console.log("getOverviewConfigcallback configdata---", configdata);
          const filteredOverviewConfig = configdata.map((param, idx) => {
            let TagIDArray = param.TagID;
            // let finalTagIDArray = [];
            // console.log("devicedetailsobject",devicedetailsobject)
            // for(let j=0;j<TagIDArray.length;j++){
            //   const parameter = TagIDArray[j];
            //   console.log("parameter",parameter)
            //   finalTagIDArray.push(`${parameter}~${devicedetailsobject[tagdetailsobject[parameter].DeviceID].Name || ''}~${tagdetailsobject[parameter].Name || ''}~${devicedetailsobject[tagdetailsobject[parameter].DeviceID].Name || ''}~${tagdetailsobject[parameter].Name || ''}~${parameter.RepresentType}`)
            // }

            return {
              id: param.id,
              name: param.ParameterName || '',
              parameterType: param.Type === 'Tag' ? 'tag' : param.Type === 'Manual' ? 'manual' : '',
              selectedDevices: [], // If you have device info, map it here
              selectedTags: param.tagDetailsArray || [],
              targetSelection: param.tagSelection || {
                yearlyBaseline: param.Type === 'YEARLYBASELINE',
                target: param.Type === 'TARGET',
                manualValue: '',
                manualUnit: ''
              },
              aggregation: param.Aggregations && param.Aggregations.length > 0 ? param.Aggregations[0] : 'Sum',
              timePeriod: param.TimePeriod || 'Today',
              unitSelection: param.UnitSelection || '',
              iconPath: param.IconPath || '',
              iconData: param.IconData || { base64: '', height: '', width: '' },
              showInCollapsedMode: param.isShowCollapsedMode,
              showAsCriticalParameter: param.isCriticalParameter,
              displayOrder: typeof param.DisplayOrder === 'number' ? param.DisplayOrder : idx,
              isDisplayed: true,
              plantDetails: {
                clientType: param.PlantDetails?.ClientType || 'organization',
                clientValue: param.PlantDetails?.ClientValue || '',
                projectType: param.PlantDetails?.ProjectType || 'project',
                projectValue: param.PlantDetails?.ProjectValue || '',
                selectedProjectDetail: param.PlantDetails?.SelectedProjectDetail || 'Country',
                customFieldType: param.PlantDetails?.CustomFieldType || 'projectDetail',
                selectedAdditionalFieldDetail: param.PlantDetails?.selectedAdditionalFieldDetail || 'Country',
                customFieldName: param.PlantDetails?.customFieldName || '',
                customFieldValue: param.PlantDetails?.CustomFieldValue || '',
                plantIconPath: param.PlantDetails?.plantIconPath || '',
                plantIconData: param.PlantDetails?.plantIconData || { base64: '', height: '', width: '' }
              }
            }});
            console.log("filteredOverviewConfig----", filteredOverviewConfig);
            console.log("configdata----", configdata);
          dispatch(updateoverviewbarCollection(configdata));
          dispatch(updateoverviewbarConfigCollection(filteredOverviewConfig));
        }else{
          dispatch(updateoverviewbarCollection([]));
          dispatch(updateoverviewbarConfigCollection([]));
        }
  };

   //Refining with HTML Superscript approach
  const getUnitWithPower = (unit) => {
      const powers = {
        'Milli': 'm',   // 10⁻³
        'Centi': 'c',   // 10⁻²
        'Deci':  'd',   // 10⁻¹
        'Unit':  '',    // 10⁰ (no prefix)
        'Deca':  'da',  // 10¹
        'Hecto': 'h',   // 10²
        'Kilo':  'k',   // 10³
        'Mega':  'M',   // 10⁶
        'Giga':  'G',   // 10⁹
        'Tera':  'T'    // 10¹²
      };
      
      // Return the mapped value, or the original unit if not found in the map
      return powers[unit] !== undefined ? powers[unit] : unit;
    };
  
   useEffect(()=>{
      console.log("overviewbarCollection----////",overviewbarCollection,"projectname",projectname,userdetails.User_Role_Details.Name)
      console.log("liveoverviewdata----//// Overviewbar",liveoverviewdata)  
        setCriticalExpandParameters(overviewbarCollection.filter(param => param.isCriticalParameter).map(param => {
            const tagRef = tagdetailsobject[param.TagID[0]];
            const tagUnit = tagRef?.Unit || '';
            const { base, multiplier } = parseUnit(tagUnit || '');
            console.log(" setCriticalExpandParametersbase",base,"multiplier",multiplier)
            // let basicUnit = '';
            // if(base == ''){
            //   basicUnit = tagUnit;
            // }
            
              
                if (param.RepresentType !== 'LIVE' || param.TagID == 'TAG_TARGET' || param.TagID == 'TAG_YEARLY_BASELINE') {
                    if(param.Type === 'Manual'){
                        let baseValue = Number(param.tagSelection.manualValue);
                        const scale = prefixMultipliersParamUnit[param.Unit] || 1;
                        const scaledValue = baseValue * scale;
                        return {
                          Name:param.ParameterName,
                          Unit: param.Unit != "Unit" ? "(" + getUnitWithPower(param.Unit) + "" + param.tagSelection.manualUnit + ")" : param.tagSelection.manualUnit,
                          Value: Number(scaledValue).toFixed(2),
                          logobase64: param.IconData?.base64 || '',
                          isLive: false,
                          timestamp:''
                        };
                    }else{
                        let baseValue = param.data * multiplier;
                        const scale = prefixMultipliersParamUnit[param.Unit] || 1;
                        const scaledValue = baseValue * scale;
                        return {
                          Name:param.ParameterName,
                          Unit: (param.TagID == 'TAG_TARGET' || param.TagID == 'TAG_YEARLY_BASELINE') ? "(" + getUnitWithPower(param.Unit) + "" + param.configuredUnit + ")" : (param.Unit != "Unit" ? "(" + getUnitWithPower(param.Unit) + "" + base + ")" : "(" +base + ")"),
                          Value: Number(scaledValue).toFixed(2),
                          logobase64: param.IconData?.base64 || '',
                          isLive: false,
                          timestamp:''
                        };
                    }
                
                } else {
                  // Find the live data for this TagID
                  const liveDataValue = (liveoverviewdata[param.ParameterName] && liveoverviewdata[param.ParameterName].value !== null && liveoverviewdata[param.ParameterName].value !== undefined)?Number(liveoverviewdata[param.ParameterName].value):"N.A";
                  let displayValue;
                  if (liveDataValue === "N.A") {
                    displayValue = "N.A";
                  } else {
                    let baseValue = liveDataValue * multiplier;
                    const scale = prefixMultipliersParamUnit[param.Unit] || 1;
                    const scaledValue = baseValue * scale;
                    displayValue = Number(scaledValue).toFixed(2);
                  }
                  return {
                    Name:param.ParameterName,
                    Unit: "(" + getUnitWithPower(param.Unit)+""+base + ")",
                    Value: displayValue,
                    logobase64: param.IconData?.base64 || '',
                    isLive: true,
                    timestamp: ''
                  };
                }
            
            
        }));
        setNoncriticalExpandParameters(overviewbarCollection.filter(param => !param.isCriticalParameter).map(param => {
            const tagRef = tagdetailsobject[param.TagID[0]];
            const tagUnit = tagRef?.Unit || '';
          
            const { base, multiplier } = parseUnit(tagUnit || '');
                // console.log("setNoncriticalExpandParameters tagRef",tagRef,"tagUnit",tagUnit,"param",param,"getUnitWithPower(param.Unit)",getUnitWithPower(param.Unit),"Base",base,"multiplier",multiplier)

                if (param.RepresentType !== 'LIVE' || param.TagID == 'TAG_TARGET' || param.TagID == 'TAG_YEARLY_BASELINE') {
                    if(param.Type === 'Manual'){
                        let baseValue = Number(param.tagSelection.manualValue);
                        const scale = prefixMultipliersParamUnit[param.Unit] || 1;
                        const scaledValue = baseValue * scale;
                        return {
                          Name:param.ParameterName,
                          Unit: param.Unit != "Unit" ? "(" + getUnitWithPower(param.Unit) + "" + param.tagSelection.manualUnit + ")" : param.tagSelection.manualUnit,
                          Value: Number(scaledValue).toFixed(2),
                          logobase64: param.IconData?.base64 || '',
                          isLive: false,
                          timestamp:''
                        };
                    }else{
                        let baseValue = param.data * multiplier;
                        const scale = prefixMultipliersParamUnit[param.Unit] || 1;
                        const scaledValue = baseValue * scale;
                        return {
                          Name:param.ParameterName,
                          Unit: (param.TagID == 'TAG_TARGET' || param.TagID == 'TAG_YEARLY_BASELINE') ? "(" + getUnitWithPower(param.Unit) + "" +  param.configuredUnit + ")" : (param.Unit != "Unit" ? "(" + getUnitWithPower(param.Unit) + "" + base + ")" : "(" +base + ")"),
                          Value: Number(scaledValue).toFixed(2),
                          logobase64: param.IconData?.base64 || '',
                          isLive: false,
                          timestamp:''
                        };
                    }
                } else {
                  // Find the live data for this TagID
                  const liveDataValue = (liveoverviewdata[param.ParameterName] && liveoverviewdata[param.ParameterName].value !== null && liveoverviewdata[param.ParameterName].value !== undefined)?Number(liveoverviewdata[param.ParameterName].value):"N.A";
                  let displayValue;
                  if (liveDataValue === "N.A") {
                    displayValue = "N.A";
                  } else {
                    let baseValue = liveDataValue * multiplier;
                    const scale = prefixMultipliersParamUnit[param.Unit] || 1;
                    const scaledValue = baseValue * scale;
                    displayValue = Number(scaledValue).toFixed(2);
                  }
                  return {
                    Name:param.ParameterName,
                    Unit: "(" + getUnitWithPower(param.Unit) + "" + base + ")",
                    Value: displayValue,
                    logobase64: param.IconData?.base64 || '',
                    isLive: true,
                    timestamp: ''
                  };
                }
            
            
        }));
        setCriticalCollapseParameters(overviewbarCollection.filter(param => param.isCriticalParameter && param.isShowCollapsedMode).map(param => {
            const tagRef = tagdetailsobject[param.TagID[0]];
            const tagUnit = tagRef?.Unit || '';
            const { base, multiplier } = parseUnit(tagUnit || '');
                if (param.RepresentType !== 'LIVE' || param.TagID == 'TAG_TARGET' || param.TagID == 'TAG_YEARLY_BASELINE') {
                  if(param.Type === 'Manual'){
                      let baseValue = Number(param.tagSelection.manualValue);
                      const scale = prefixMultipliersParamUnit[param.Unit] || 1;
                      const scaledValue = baseValue * scale;
                      return {
                        Name:param.ParameterName,
                        Unit: param.Unit != "Unit" ? "(" + getUnitWithPower(param.Unit) + "" + param.tagSelection.manualUnit + ")" : param.tagSelection.manualUnit,
                        Value: Number(scaledValue).toFixed(2),
                        logobase64: param.IconData?.base64 || '',
                        isLive: false,
                        timestamp:''
                      };
                  }else{
                      let baseValue = param.data * multiplier;
                      const scale = prefixMultipliersParamUnit[param.Unit] || 1;
                      const scaledValue = baseValue * scale;
                      return {
                        Name:param.ParameterName,
                        Unit: (param.TagID == 'TAG_TARGET' || param.TagID == 'TAG_YEARLY_BASELINE') ? "(" + getUnitWithPower(param.Unit) + "" +  param.configuredUnit + ")" : (param.Unit != "Unit" ? "(" + getUnitWithPower(param.Unit) + "" + base + ")" : "(" +base + ")"),
                        Value: Number(scaledValue).toFixed(2),
                        logobase64: param.IconData?.base64 || '',
                        isLive: false,
                        timestamp:''
                      };
                  }
                } else {
                  // Find the live data for this TagID
                  const liveDataValue = (liveoverviewdata[param.ParameterName] && liveoverviewdata[param.ParameterName].value !== null && liveoverviewdata[param.ParameterName].value !== undefined)?Number(liveoverviewdata[param.ParameterName].value):"N.A";
                  let displayValue;
                  if (liveDataValue === "N.A") {
                    displayValue = "N.A";
                  } else {
                    let baseValue = liveDataValue * multiplier;
                    const scale = prefixMultipliersParamUnit[param.Unit] || 1;
                    const scaledValue = baseValue * scale;
                    displayValue = Number(scaledValue).toFixed(2);
                  }
                  return {
                    Name:param.ParameterName,
                    Unit: "(" + getUnitWithPower(param.Unit)+""+base + ")",
                    Value: displayValue,
                    logobase64: param.IconData?.base64 || '',
                    isLive: true,
                    timestamp:''
                  };
                }
          
        }));
        setNonCriticalCollapseParameters(overviewbarCollection.filter(param => !param.isCriticalParameter && param.isShowCollapsedMode).map(param => {
            const tagRef = tagdetailsobject[param.TagID[0]];
            const tagUnit = tagRef?.Unit || '';
            const { base, multiplier } = parseUnit(tagUnit || '');
            if (param.RepresentType !== 'LIVE' || param.TagID == 'TAG_TARGET' || param.TagID == 'TAG_YEARLY_BASELINE') {
                if(param.Type === 'Manual'){
                    let baseValue = Number(param.tagSelection.manualValue);
                    const scale = prefixMultipliersParamUnit[param.Unit] || 1;
                    const scaledValue = baseValue * scale;
                    return {
                      Name:param.ParameterName,
                      Unit: param.Unit != "Unit" ? "(" + getUnitWithPower(param.Unit) + "" + param.tagSelection.manualUnit + ")" : param.tagSelection.manualUnit,
                      Value: Number(scaledValue).toFixed(2),
                      logobase64: param.IconData?.base64 || '',
                      isLive: false,
                      timestamp:''
                    };
                }else{
                    let baseValue = param.data * multiplier;
                    const scale = prefixMultipliersParamUnit[param.Unit] || 1;
                    const scaledValue = baseValue * scale;
                    return {
                      Name:param.ParameterName,
                      Unit: (param.TagID == 'TAG_TARGET' || param.TagID == 'TAG_YEARLY_BASELINE') ? "(" + getUnitWithPower(param.Unit) + "" +  param.configuredUnit + ")" : (param.Unit != "Unit" ? "(" + getUnitWithPower(param.Unit) + "" + base + ")" : "(" +base + ")"),
                      Value: Number(scaledValue).toFixed(2),
                      logobase64: param.IconData?.base64 || '',
                      isLive: false,
                      timestamp:''
                    };
                }
              } else {
                // Find the live data for this TagID
                const liveDataValue = (liveoverviewdata[param.ParameterName] && liveoverviewdata[param.ParameterName].value !== null && liveoverviewdata[param.ParameterName].value !== undefined)?Number(liveoverviewdata[param.ParameterName].value):"N.A";
                let displayValue;
                if (liveDataValue === "N.A") {
                  displayValue = "N.A";
                } else {
                  let baseValue = liveDataValue * multiplier;
                  const scale = prefixMultipliersParamUnit[param.Unit] || 1;
                  const scaledValue = baseValue * scale;
                  displayValue = Number(scaledValue).toFixed(2);
                }
                return {
                  Name:param.ParameterName,
                  Unit: "(" + getUnitWithPower(param.Unit) + "" + base + ")",
                  Value: displayValue,
                  logobase64: param.IconData?.base64 || '',
                  isLive: true,
                  timestamp: ''
                };
              }
        
          
        }));
  },[overviewbarCollection,liveoverviewdata])

  // useEffect(()=>{
  //   console.log("before calling projectid",projectname)
  //     getOverviewConfig(selecteddates_dashboard.startdates, selecteddates_dashboard.enddates, dateselected, getOverviewConfigcallback);
  // },[projectname, selecteddates_dashboard])

  function getOverviewbarDatacallback(res) {
    if (res.status == 201 && res.data.data.length !== 0) {
      //console.log("res.data.data ", res.data.data, res.data.data[0].length);
      if (res.data.data[0].length === 0) {
        setoverviewbarData([
          [0, 0, 0],
          [0, 0, 0],
        ]);
      } else {
        setoverviewbarData(res.data.data);
      }
    } else {
      setoverviewbarData([
        [0, 0, 0],
        [0, 0, 0],
      ]);
    }
  }

  const getOverviewbarParameterDatacallback = (res) => {
    console.log("getOverviewbarParameterDatacallback res", res);
  };

  // Default white circle logo (empty white circle SVG as base64)
  const defaultLogoBase64 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMTkuNSIgZmlsbD0id2hpdGUiIHN0cm9rZT0iIzAwOENENyIvPgo8L3N2Zz4K";

  useEffect(() => {

    if (userdetails.Projectid === "All") {
      if (projectname !== "All") {
        getOverviewbarData(
          getOverviewbarDatacallback
        );
      } else {
        getOverviewbarData(
          getOverviewbarDatacallback
        );
      }
    } else {
      getOverviewbarData(
        getOverviewbarDatacallback
      );
    }

    var projectlist = [];
    if (projectdetails.length) {
      for (let i = 0; i < projectdetails.length; i++) {
        //console.log("projectdetails ",projectdetails[i])
        // if (userdetails.hasOwnProperty("Projectlist")) {
        //   for (let j = 0; j < userdetails.Projectlist.length; j++) {
        //     if (userdetails.Projectlist[j] === projectdetails[i].ProjectId) {
        //       projectlist.push({
        //         client: organizationdetails.Organizationname,
        //         project: projectdetails[i].Projectname,
        //         place: projectdetails[i].Projectdetails.State,
        //         projectid: projectdetails[i].ProjectId,
        //       });
        //       setLogobase64(projectdetails[i].Logo.base64);
        //       break;
        //     }
        //   }
        // } else {
        projectlist.push({
          client: organizationdetails.Organizationname,
          project: projectdetails[i].Projectname,
          place: projectdetails[i].Projectdetails.State,
          projectid: projectdetails[i].ProjectId,
          location: projectdetails[i].Projectdetails.Location,
        });
        setLogobase64(projectdetails[i].Logo.base64 || defaultLogoBase64);
        //}
      }
      setProjectlist(projectlist);
      
      if (!projectname || projectname === 'All') {
          setClientdatajson(projectlist[0]);
          //dispatch(updatepreviousselectedprojectname(projectlist[0].projectid));
          dispatch(updateselectedprojectname(projectlist[0].projectid));
      } else {
          // Find the current project in the new list and update clientdatajson
          const currentProject = projectlist.find(p => p.projectid === projectname);
          
          if (currentProject) {
              setClientdatajson(currentProject);
          }
      }
    }
  }, [projectname]);

  useEffect(() => {
    if (userdetails.Projectid === "All") {
      if (projectname !== "All") {
        getOverviewbarData(
          getOverviewbarDatacallback
        );
      } else {
        getOverviewbarData(
          getOverviewbarDatacallback
        );
      }
    } else {
      getOverviewbarData(
        getOverviewbarDatacallback
      );
    }

  }, [projectname]);

  return (
    <Box className={isExpanded ? "overview" : "overview-expand"}>
      {isExpanded && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            gap: "8px",
          }}
        >
          <div className="card1">
            <div
              style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  overflow: "hidden",
                  border: "1.5px solid #008CD7",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#fff"
                }}
            >
             <img
                  src={logobase64 || defaultLogoBase64}
                  alt="Plant Logo"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "50%",
                  }}
                />
            </div>
            <div
              className="cardtext"
              style={{ marginBottom: "0px", paddingBottom: 0, paddingTop: 0 }}
            >
              <Typography
                className="client-heading"
                style={{ fontSize: "14px", fontWeight: 400 }}
              >
                Client
              </Typography>
              <Typography
                className="client-name"
                style={{
                  fontSize: "14px",
                  fontWeight: 400,
                  marginTop: "20px",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                {clientdatajson.client}
              </Typography>
            </div>
            {/* <div className="cardtext">
                                <Typography className="client-heading" style={{fontSize: '14px', fontWeight: 400}}>Sub Tenant</Typography>
                                <Typography className="client-name" style={{fontSize: '16px', fontWeight: 400}}>Sub Tenant Name</Typography>
                            </div> */}
            <div
              className="cardtext"
              style={{
                marginBottom: "0px",
                paddingBottom: 0,
                paddingTop: 0,
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              <Typography
                className="client-heading"
                style={{ fontSize: "14px", fontWeight: 400 }}
              >
                Name
              </Typography>
              <Typography
                className="client-name"
                style={{ fontSize: "14px", fontWeight: 400, marginTop: "20px" }}
              >
                {clientdatajson.project}
              </Typography>
            </div>
            <div
              className="cardtext"
              style={{
                marginBottom: "0px",
                paddingBottom: 0,
                paddingTop: 0,
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              <Typography
                className="client-heading"
                style={{ fontSize: "14px", fontWeight: 400 }}
              >
                Location
              </Typography>
              <Typography
                className="client-name"
                style={{ fontSize: "14px", fontWeight: 400, marginTop: "20px" }}
              >
                {clientdatajson.place}
              </Typography>
            </div>
            <div className="cardtext" style={{ marginBottom: "0px" }}></div>
            <KeyboardArrowDownIcon
              style={{
                height: "28px",
                width: "28px",
                color: "var(--PrimaryText)",
                paddingTop: "4px",
                marginLeft: "-8px",
                paddingRight: "4px",
              }}
              onClick={handleClick}
            />
            <Menu
              anchorEl={anchorE1}
              open={Boolean(anchorE1)}
              onClose={handleClose}
              onClick={handleClose}
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
              transformOrigin={{ vertical: "bottom", horizontal: "right" }}
              sx={{
                marginTop: "140px",
                "& .MuiMenu-paper": {
                  width: "460px",
                  height: "320px",
                  backgroundColor:
                    themechange === "dark" ? "#1E1E1E" : "#FFFFFF",
                  color: themechange === "dark" ? "#FFFFFF" : "#3C3C3C",
                  borderRadius: "0px",
                  border: "1.5px solid",
                  borderColor: "#008CD7",
                },
              }}
            >
              <Table
                sx={{
                  width: "100%",
                  [`& .${tableCellClasses.root}`]: {
                    borderBottom: "none",
                  },
                  "& .MuiTableRow-root:hover": {
                    backgroundColor: "#005C8E",
                    color: "#FFFFFF !important",
                  },
                }}
              >
                <TableHead>
                  <TableRow
                    sx={{
                      "&:hover .MuiTableCell-root, &:hover .material-icons-outlined":
                        {
                          color: "#FFFFFF !important",
                        },
                    }}
                  >
                    <TableCell
                      style={{
                        color: themechange === "dark" ? "#FFFFFF" : "#3C3C3C",
                      }}
                    >
                      {" "}
                      Client{" "}
                    </TableCell>
                    <TableCell
                      style={{
                        color: themechange === "dark" ? "#FFFFFF" : "#3C3C3C",
                      }}
                    >
                      {" "}
                      Name{" "}
                    </TableCell>
                    <TableCell
                      style={{
                        color: themechange === "dark" ? "#FFFFFF" : "#3C3C3C",
                      }}
                    >
                      {" "}
                      Location{" "}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {projectlist.map((row, index) => (
                    <TableRow
                      key={row.project}
                      onClick={() => handletablerowclick(row, index)}
                      sx={{
                        "&:hover .MuiTableCell-root, &:hover .material-icons-outlined":
                          {
                            color: "#FFFFFF !important",
                          },
                      }}
                    >
                      <TableCell
                        style={{
                          color: themechange === "dark" ? "#FFFFFF" : "#3C3C3C",
                          fontSize: "14px",
                          fontWeight: 500,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {" "}
                        {row.client}{" "}
                      </TableCell>
                      <TableCell
                        style={{
                          color: themechange === "dark" ? "#FFFFFF" : "#3C3C3C",
                          fontSize: "14px",
                          fontWeight: 500,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {" "}
                        {row.project}{" "}
                      </TableCell>
                      <TableCell
                        style={{
                          color: themechange === "dark" ? "#FFFFFF" : "#3C3C3C",
                          fontSize: "14px",
                          fontWeight: 500,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {" "}
                        {row.location}{" "}                     
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Menu>
          </div>
          <div className="card2" style={{ display: "flex", flexDirection: "row", flex: 1, overflow: "hidden" }}>
            {/* Combine all parameters into a single array and render them together */}
            {(() => {
              // Combine non-critical and critical parameters
              const allParameters = [
                ...(Array.isArray(noncriticalExpandParameters) ? noncriticalExpandParameters.map(p => ({ ...p, isCritical: false })) : []),
                ...(Array.isArray(criticalExpandParameters) ? criticalExpandParameters.map(p => ({ ...p, isCritical: true })) : [])
              ];

              // If no parameters, return null
              if (allParameters.length === 0) return null;

              return allParameters.map((param, idx, array) => {
                if (
                  param &&
                  typeof param === "object" &&
                  typeof param.Name === "string" &&
                  "Unit" in param &&
                  "Value" in param
                ) {
                  return (
                    <React.Fragment key={idx}>
                      <div
                        className="cardtext"
                        style={{
                          flex: 1, // Each parameter gets equal width (33.33% for 3 params)
                          minWidth: 0,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "78px",
                          background: param.isCritical ? "#005C8E" : "transparent",
                          color: param.isCritical ? "var(--White)" : "inherit",
                          marginBottom: "0px",
                          paddingTop: "4px",
                          paddingBottom: "0px",
                        }}
                      >
                        <div 
                          style={{ 
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            textAlign: "center"
                          }}
                        >
                          <Typography
                            style={{
                              fontSize: "14px",
                              fontWeight: 400,
                              marginTop: "-2px",
                              wordBreak: "break-word",
                              whiteSpace: "normal",
                              maxWidth: "100%",
                              color: param.isCritical ? "var(--White)" : "inherit"
                            }}
                          >
                            {param.isLive && (
                              <span style={{ color: param.isCritical ? "#FFFFFF" : "#008CD7", marginRight: "4px" }}>Live</span>
                            )}
                            {param.Name} {param.Unit !== "Unit" && param.Unit !== "" ? param.Unit : ""}
                          </Typography>
                        </div>
                        
                        <div 
                          style={{ 
                            display: "flex", 
                            gap: "8px",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "4px"
                          }}
                        >
                          {param.logobase64 !== "" && (
                            <img
                              src={param.logobase64}
                              alt="Plant Logo"
                              style={{
                                height: "30px",
                                width: "30px",
                                borderRadius: "50%",
                                border: "0.5px solid #008CD7"
                              }}
                            />
                          )}
                          <Typography
                            style={{
                              fontSize: "24px",
                              fontWeight: 400,
                              marginTop: "-2px",
                              color: param.isCritical ? "var(--White)" : "inherit"
                            }}
                          >
                            {isInitialLoading && (param.Value === "N.A" || param.Value === null || param.Value === undefined) ? (
                              <CircularProgress size={20} style={{ color: param.isCritical ? "var(--White)" : "var(--LK_BrandBlue)" }} />
                            ) : (
                              param.Value !== undefined && param.Value !== null && !isNaN(param.Value) && param.Value !== "N.A" ? param.Value : "N.A"
                            )}
                          </Typography>
                        </div>
                      </div>
                      
                      {idx < array.length - 1 && (
                        <Divider
                          orientation="vertical"
                          variant="middle"
                          sx={{ background: param.isCritical ? "var(--Overviewbar_divider)" : "var(--GreyVariation_2)" }}
                          flexItem
                        />
                      )}
                    </React.Fragment>
                  );
                }
                return null;
              });
            })()}
          </div>
          <div className="card3" style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
            <CustomTooltip title={"Home"} offset={[30,-20]} placement={'right-end'}>
            <div
              className="cardtextrow"
              style={{ margin: "18px 5px 20px 12px", cursor: "pointer" }}
              onClick={() => handlePageChange("home")}
            >
              {!showsuper && (
                <LK_Home
                  color={
                    selectedPage === "home"
                      ? "var(--LK_BrandBlue)"
                      : "var(--IconColor)"
                  }
                  width={"27px"}
                  height={"27px"}
                />
              )}
            </div>
            </CustomTooltip>
            
            <ProtectedComponent
              permission="PALV67"
              userPermissions={userPermissions}
            >
              <CustomTooltip title={"Alerts"} offset={[30,-20]} placement={'right-end'}>
              <div
                className="cardtextrow"
                style={{ margin: "18px 0px 20px 6px", cursor: "pointer" }}
                onClick={() => handlePageChange("alarm")}
              >
                {!showsuper && usrPrmns.includes("PALV67") && (
                  <IconButton
                    sx={{ margin: "0px", padding: "0px" }}
                    aria-label={notificationsLabel(count_of_alarms_events)}
                    disableRipple
                    onClick={() => handlePageChange("alarm")}
                  >
                    <Badge
                      sx={{ margin: "0px", padding: "0px" }}
                      badgeContent={count_of_alarms_events}
                      disableRipple
                      color="secondary"
                    >
                      {/* <MailIcon /> */}
                      <LK_Alarm
                        color={
                          selectedPage === "alarm"
                            ? "var(--LK_BrandBlue)"
                            : "var(--IconColor)"
                        }
                        width={"27px"}
                        height={"27px"}
                      />
                    </Badge>
                  </IconButton>
                )}
              </div>
               </CustomTooltip>
            </ProtectedComponent>
           
            <CustomTooltip title={"Reports"} offset={[30,-20]} placement={'right-end'}>
            <div
              className="cardtextrow"
              style={{ margin: "18px 0px 20px 12px", cursor: "pointer" }}
              onClick={() => handlePageChange("reporting")}
            >
              {!showsuper && usrPrmns.includes("PRGN60") && (
                <LK_Reports
                  color={
                    selectedPage === "reporting"
                      ? "var(--LK_BrandBlue)"
                      : "var(--IconColor)"
                  }
                  width={"27px"}
                  height={"27px"}
                />
              )}
            </div>
             </CustomTooltip>
            <CustomTooltip title={"Configuration"} offset={[30,-20]} placement={'right-end'}>
            { usrPrmns.includes("PCOV78")  && (
              <div
                className="cardtextrow"
                style={{ margin: "18px 0px 20px 12px", cursor: "pointer" }}
                onClick={() => handlePageChange("config")}
              >
                {!showsuper && (
                  <LK_Settings
                    color={
                      selectedPage === "config"
                        ? "var(--LK_BrandBlue)"
                        : "var(--IconColor)"
                    }
                    width={"27px"}
                    height={"27px"}
                  />
                )}
              </div>
            )}
            </CustomTooltip>
            <ProtectedComponent
              permission="PTKC73"
              userPermissions={userPermissions}
            >
              <CustomTooltip title={"Ticket"} offset={[30,-20]} placement={'right-end'}>
              <div
                className="cardtextrow"
                style={{ margin: "18px 0px 20px 6px", cursor: "pointer" }}
                onClick={() => handlePageChange("ticket")}
              >
                {!showsuper && (
                  <LK_Ticket
                    color={
                      selectedPage === "ticket"
                        ? "var(--LK_BrandBlue)"
                        : "var(--IconColor)"
                    }
                    width={"27px"}
                    height={"27px"}
                  />
                )}
              </div>
              </CustomTooltip>
            </ProtectedComponent>
            
            <ProtectedComponent
                            permission="PAUV72" 
                            userPermissions={userPermissions}
                          >
            <CustomTooltip title={"Audit Logs"} offset={[30,-20]} placement={'right-end'}>
            <div
              className="cardtextrow"
              style={{ margin: "18px 0px 20px 6px", cursor: "pointer" }}
              onClick={() => handlePageChange("audit")}
            >
              {!showsuper && (
                <LK_Audit
                  color={
                    selectedPage === "audit"
                      ? "var(--LK_BrandBlue)"
                      : "var(--IconColor)"
                  }
                  width={"27px"}
                  height={"27px"}
                />
              )}
            </div>
            </CustomTooltip>
            </ProtectedComponent>
            

            {/*<div className="cardtextrow" style={{ margin: "18px 5px 20px 12px", cursor: "pointer" }} onClick={() => handlePageChange('home')}>
                                {selectedPage === 'home' && <LK_Home color='var(--LK_BrandBlue)' width={"30px"} height={"30px"}/>}
                                {selectedPage === 'config' && <LK_Home color='var(--IconColor)' width={"30px"} height={"30px"}/>} 
                                {selectedPage === 'usermanage' && <LK_Home color='var(--IconColor)' width={"30px"} height={"30px"}/>} 
                            </div>
                            <div className="cardtextrow" style={{ margin: "18px 5px 20px 12px", cursor: "pointer" }} onClick={() => handlePageChange('config')}>
                                {selectedPage === 'home' && <LK_Settings color='var(--IconColor)' width={"30px"} height={"30px"}/>}
                                {selectedPage === 'config' && <LK_Settings color='var(--LK_BrandBlue)' width={"30px"} height={"30px"}/>}
                                {selectedPage === 'usermanage' && <LK_Settings color='var(--IconColor)' width={"30px"} height={"30px"}/>}
                            </div>
                            <div className="cardtextrow" style={{ margin: "18px 0px 20px 12px", cursor: "pointer" }} onClick={() => handlePageChange('usermanage')}>
                                {selectedPage === 'home' && <LK_Useradministration color='var(--IconColor)' width={"30px"} height={"30px"}/>}
                                {selectedPage === 'config' && <LK_Useradministration color='var(--IconColor)' width={"30px"} height={"30px"}/>}
                                {selectedPage === 'usermanage' && <LK_Useradministration color='var(--LK_BrandBlue)' width={"30px"} height={"30px"}/>}
                            </div>*/}
          </div>
        </div>
      )}
      {!isExpanded && (
        <div className="overview-header">
          <Box className="keyparameter-list">
            <Typography
              style={{ fontSize: "16px", fontWeight: 400, marginRight: "40px" }}
            >
              {" "}
              Client Info{" "}
            </Typography>
            <Typography
              style={{ fontSize: "16px", fontWeight: 400, marginRight: "40px" }}
            >
              {" "}
              {clientdatajson.client}{" "}
            </Typography>
            {/* <Typography  style={{fontSize: '16px', fontWeight: 400, marginRight: '40px'}}> Sub Tenant Name </Typography> */}
            <Typography
              style={{ fontSize: "16px", fontWeight: 400, marginRight: "40px" }}
            >
              {" "}
              {clientdatajson.project}{" "}
            </Typography>
            <Typography
              style={{ fontSize: "16px", fontWeight: 400, marginRight: "40px" }}
            >
              {" "}
              {clientdatajson.place}{" "}
            </Typography>
          </Box>
          {/* <Box
            className="keyparameter-list"
            style={{
              display: "flex",
              flexGrow: "1",
              justifyContent: "space-between",
              marginLeft: "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                height: "100%",
                
              }}
            >
              <Divider
              orientation="vertical"
              variant="fullWidth"
              sx={{ background: "var(--GreyVariation_2)" }}
              flexItem
            />
              {Array.isArray(noncriticalCollapseParameters) && noncriticalCollapseParameters.length > 0 &&
                  noncriticalCollapseParameters.map((param, idx) => {
                    if (
                      param &&
                      typeof param === "object" &&
                      typeof param.Name === "string" &&
                      "Unit" in param &&
                      "Value" in param
                    ) {
                      return (
                        <React.Fragment key={idx}>
                          <div style={{ marginRight: "8px", marginLeft: "8px", backgroundColor: "var(--SecondaryBackground)" }}>
                            <Typography
                              className="keyparameter-font"
                              style={{ fontSize: "16px", fontWeight: 400, textAlign: "left" }}
                            >
                              {param.Name} {param.Unit === "Unit" ? "" : param.Unit}
                            </Typography>
                            <div style={{ display: "flex", gap: "20px" }}>
                              {param.logobase64 != "" && <img
                                  src={param.logobase64}
                                  alt="Plant Logo"
                                  style={{
                                    height: "30px",
                                    width: "30px",
                                    marginLeft: "-1.0px",
                                    marginTop: "-3px",
                                    borderRadius: "50%", // Makes the image circular
                                    border: "0.5px solid #008CD7" // Optional: adds a border
                                  }}
                                />}
                           <Typography
                                style={{
                                  fontSize: "24px",
                                  fontWeight: 400,
                                  marginTop: "-2px",
                                }}
                              >
                                {param.Value !== undefined && param.Value !== null ? param.Value : "--"}
                              </Typography>
   
                              <div>
                                {param.isLive ? (
                                  <BlurCircularIcon
                                    sx={{
                                      color: "#008CD7",
                                      fontSize: "16px",
                                      marginTop: "10px",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                          <Divider
                            orientation="vertical"
                            variant="fullWidth"
                            sx={{ background: "var(--GreyVariation_2)" }}
                            flexItem
                          />
                        </React.Fragment>
                      );
                    }
                    // If param is invalid, render nothing
                    return null;
                  })}

            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                background: "var(--LK_BrandBlue)",
                color: "var(--White)",
                height: "100%",
              }}
            >
              <Divider
              orientation="vertical"
              variant="fullWidth"
              sx={{ background: "var(--LK_BrandBlue)" }}
              flexItem
            />
                 {Array.isArray(criticalCollapseParameters) && criticalCollapseParameters.length > 0 &&
                    criticalCollapseParameters.map((param, idx) => {
                      // Defensive checks for param and its fields
                      if (
                        param &&
                        typeof param === "object" &&
                        typeof param.Name === "string" &&
                        "Unit" in param &&
                        "Value" in param
                      ) {
                        return (
                          <React.Fragment key={idx}>
                            <div style={{ marginRight: "8px", marginLeft: "8px" }}>
                              <Typography
                                className="keyparameter-font"
                                style={{
                                  fontSize: "16px",
                                  fontWeight: 400,
                                  textAlign: "left",
                                  color: "var(--White)",
                                }}
                              >
                                {param.Name} {param.Unit === "Unit" ? "" : param.Unit}
                              </Typography>
                              <div style={{ display: "flex", gap: "20px" }}>
                                {param.logobase64 != "" && <img
                                  src={param.logobase64}
                                  alt="Plant Logo"
                                  style={{
                                    height: "30px",
                                    width: "30px",
                                    marginLeft: "-1.0px",
                                    marginTop: "-3px",
                                    borderRadius: "50%", // Makes the image circular
                                    border: "0.5px solid #008CD7" // Optional: adds a border
                                  }}
                                />}
                             <Typography
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 400,
                                    marginTop: "-2px",
                                  }}
                                >
                                  {param.Value !== undefined && param.Value !== null ? param.Value : "--"}
                                </Typography>
   
                                <div>
                                  {param.isLive ? (
                                    <BlurCircularIcon
                                      sx={{
                                        color: "#008CD7",
                                        fontSize: "16px",
                                        marginTop: "10px",
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </div>
                            </div>
                            <Divider
                              orientation="vertical"
                              variant="fullWidth"
                              sx={{ background: "var(--Overviewbar_divider)" }}
                              flexItem
                            />
                          </React.Fragment>
                        );
                      }
                      // If param is invalid, render nothing
                      return null;
                    })}

            </div>
            
          </Box> */}
          <Box
              className="keyparameter-list"
              style={{
                display: "flex",
                flexGrow: "1",
                justifyContent: "space-between",
                marginLeft: "auto",
              }}
            >
              {(() => {
                // Combine non-critical and critical collapse parameters
                const allCollapseParameters = [
                  ...(Array.isArray(noncriticalCollapseParameters) ? noncriticalCollapseParameters.map(p => ({ ...p, isCritical: false })) : []),
                  ...(Array.isArray(criticalCollapseParameters) ? criticalCollapseParameters.map(p => ({ ...p, isCritical: true })) : [])
                ];

                if (allCollapseParameters.length === 0) return null;

                return (
                  <>
                    <Divider
                      orientation="vertical"
                      variant="fullWidth"
                      sx={{ background: "var(--GreyVariation_2)" }}
                      flexItem
                    />
                    {allCollapseParameters.map((param, idx, array) => {
                      if (
                        param &&
                        typeof param === "object" &&
                        typeof param.Name === "string" &&
                        "Unit" in param &&
                        "Value" in param
                      ) {
                        return (
                          <React.Fragment key={idx}>
                            <div
                              className="cardtext"
                              style={{
                                flex: 1, // Each parameter gets equal width
                                minWidth: 0,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                background: param.isCritical ? "#005C8E" : "var(--SecondaryBackground)",
                                color: param.isCritical ? "var(--White)" : "inherit",
                                marginBottom: "0px",
                                paddingTop: "2px",
                                paddingBottom: "0px",
                                height: "100%"
                              }}
                            >
                              <div 
                                style={{ 
                                  display: "flex",
                                  flexWrap: "wrap",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  width: "100%",
                                  textAlign: "center"
                                }}
                              >
                                <Typography
                                  style={{ 
                                    fontSize: "14px", 
                                    fontWeight: 400,
                                    wordBreak: "break-word",
                                    whiteSpace: "normal",
                                    maxWidth: "100%",
                                    color: param.isCritical ? "var(--White)" : "inherit"
                                  }}
                                >
                                  {param.isLive && (
                                    <span style={{ color: param.isCritical ? "#FFFFFF" : "#008CD7", marginRight: "4px" }}>Live</span>
                                  )}
                                  {param.Name} {param.Unit !== "Unit" && param.Unit !== "" ? param.Unit : ""}
                                </Typography>
                              </div>
                              
                              <div 
                                style={{ 
                                  display: "flex", 
                                  gap: "8px",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  marginTop: "4px"
                                }}
                              >
                                {param.logobase64 !== "" && (
                                  <img
                                    src={param.logobase64}
                                    alt="Plant Logo"
                                    style={{
                                      height: "30px",
                                      width: "30px",
                                      borderRadius: "50%",
                                      border: "0.5px solid #008CD7"
                                    }}
                                  />
                                )}
                                <Typography
                                  style={{
                                    fontSize: "24px",
                                    fontWeight: 400,
                                    marginTop: "-2px",
                                    color: param.isCritical ? "var(--White)" : "inherit"
                                  }}
                                >
                                  {isInitialLoading && (param.Value === "N.A" || param.Value === null || param.Value === undefined) ? (
                                    <CircularProgress size={20} style={{ color: param.isCritical ? "var(--White)" : "var(--LK_BrandBlue)" }} />
                                  ) : (
                                    param.Value !== undefined && param.Value !== null && !isNaN(param.Value) && param.Value !== "N.A" ? param.Value : "N.A"
                                  )}
                                </Typography>
                              </div>
                            </div>
                            
                            {idx < array.length - 1 && (
                              <Divider
                                orientation="vertical"
                                variant="fullWidth"
                                sx={{ background: param.isCritical ? "var(--Overviewbar_divider)" : "var(--GreyVariation_2)" }}
                                flexItem
                              />
                            )}
                          </React.Fragment>
                        );
                      }
                      return null;
                    })}
                  </>
                );
              })()}
            </Box>
        </div>
      )}
      <div style={{ height: "40px" }}>
        {isExpanded ? (
          <ExpandLessOutlinedIcon
            style={{ width: "38px", height: "38px" }}
            className="un-expand"
            onClick={handleExpandClick}
          />
        ) : (
          <ExpandMoreOutlinedIcon
            style={{ width: "38px", height: "38px" }}
            className="expand"
            onClick={handleExpandClick}
          />
        )}
      </div>
    </Box>
  );
}

/*className={`expand ${isExpanded ? 'expand' : 'un-expand'}`}

<div className="cardtext" >
                                <Typography className="client-heading" style={{fontSize: '14px', fontWeight: 400}}>Work Site Name</Typography>
                                <Typography className="client-name" style={{fontSize: '18px', fontWeight: 400}}>Mumbai HQ</Typography>
                            </div>

                            <div className="cardtextrow" style={{ margin: "18px 12px 20px 12px", cursor: "pointer" }} onClick={() => handlePageChange('home')}>
                                {selectedPage === 'home' && <HomeOutlinedIcon style={{ height: '32px', width: '32px', color: 'var(--LK_BrandBlue)', paddingTop: "4px", }} />}
                                {selectedPage === 'config' && <HomeOutlinedIcon style={{ height: '32px', width: '32px', color: 'var(--PrimaryText)', paddingTop: "4px", }} />}
                            </div>
                            <div className="cardtextrow" style={{ margin: "20px 22px 22px 22px", cursor: "pointer" }} onClick={() => handlePageChange('config')}>
                                {selectedPage === 'home' && <SettingsOutlinedIcon style={{ height: '32px', width: '32px', color: "var(--PrimaryText)", paddingTop: "4px" }} />}
                                {selectedPage === 'config' && <SettingsOutlinedIcon style={{ height: '32px', width: '32px', color: "var(--LK_BrandBlue)", paddingTop: "4px" }} />}
                            </div>

{
                                    clientdatajson.client === "XYZ Company Ltd" &&
                                    <img src={plantlogo2} alt="Plant Logo" style={{height:"40px",width:"40px",marginLeft:'-1.0px',marginTop:'-3px'}}/>
                                }
                                {
                                    clientdatajson.client === "Jubilant FoodWorks Ltd" &&
                                    <img src={plantlogo3} alt="Plant Logo" style={{height:"40px",width:"40px",marginLeft:'-1.0px',marginTop:'-3px'}}/>
                                }
                                {
                                    clientdatajson.client === "DOMINOS" && 
                                    <img src={dominoslogo} alt="Plant Logo" style={{height:"40px",width:"60px",marginLeft:'-1.0px',marginTop:'-3px'}}/>
                                }  
                                {
                                    clientdatajson.client === "DUNKIN" && 
                                    <img src={dunkinlogo} alt="Plant Logo" style={{height:"50px",width:"85px",marginLeft:'-1.0px',marginTop:'-3px'}}/>
                                }
                                {
                                    clientdatajson.client === "POPEYES" && 
                                    <img src={popeyeslogo} alt="Plant Logo" style={{height:"70px",width:"110px",marginLeft:'-1.0px',marginTop:'-3px'}}/>
                                }
                                {
                                    clientdatajson.client === "HONG'S Kitchen" && 
                                    <img src={hongslogo} alt="Plant Logo" style={{height:"53px",width:"56px",marginLeft:'-1.0px',marginTop:'-3px'}}/>
                                }   

*/